import apiService from './apiService';

const PREFIX = '/rag';
const ASK_TIMEOUT_MS = 90000;

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const ragService = {
  async getClients() {
    const data = await request(apiService.get(`${PREFIX}/clients`));
    return Array.isArray(data.clients) ? data.clients : [];
  },

  async ask({ question, client, mode = 'question', top = 8 }) {
    const body = { question, mode, top };
    if (client) {
      body.client = client;
    }
    return request(apiService.post(`${PREFIX}/ask`, body, {}, { timeout: ASK_TIMEOUT_MS }));
  },
};

export default ragService;
